import PropTypes from 'prop-types';
import { Modal } from '@material-ui/core';
import { useEffect, useRef, useState } from 'react';
import TextButton from '../../../../atomic/buttons/textButton/TextButton';
import { Body1, Body2, Body3, fontSizes } from '../../../../atomic/text/Text';
import style from './AlertsUserPrefsModal.module.css';
import CheckBox from '../../../../atomic/formElements/checkBox/CheckBox';
import { BoxInput } from '../../../../atomic/inputs/boxInput/BoxInput';
import { colors } from '../../../../../colorVars';
import { sendUserPreferences } from '../../../../../stores/websocketStore/utils/outgoingMessages/userpreferences/sendUserPreferences';
import { useWebsocketStore } from '../../../../../stores/websocketStore/websocketProvider';
import { observer } from 'mobx-react-lite';
import { testAlert } from '../../../../../stores/websocketStore/utils/outgoingMessages/testalert/testAlert';
const phoneCarriers = [
  'AT&T',
  'T-Mobile',
  'Verizon',
  'Sprint',
  'Virgin Mobile',
  'Boost Mobile',
  'Cricket Wireless',
  'Google Project Fi',
  'Republic Wireless',
  'Straight Talk',
  'Ting',
  'U.S. Cellular',
];
function convertToSmsGateWay(carrierTxt) {
  switch (carrierTxt) {
    case 'AT&T':
      return 'txt.att.net';
    case 'T-Mobile':
      return 'tmomail.net';
    case 'Verizon':
      return 'vtext.com';
    case 'Sprint':
      return 'messaging.sprintpcs.com';
    case 'Virgin Mobile':
      return 'vmobl.com';
    case 'Boost Mobile':
      return 'sms.myboostmobile.com';
    case 'Cricket Wireless':
      return 'mms.cricketwireless.net';
    case 'Google Project Fi':
      return 'msg.fi.google.com';
    case 'Republic Wireless':
      return 'text.republicwireless.com';
    case 'Straight Talk':
      return 'vtext.com';
    case 'Ting':
      return 'message.ting.com';
    case 'U.S. Cellular':
      return 'email.uscc.net';
    default:
      return carrierTxt.length > 0 ? carrierTxt : ''; //perhaps already in email form
  }
}
function convertFromSmsGateWay(carrierTxt) {
  switch (carrierTxt) {
    case 'txt.att.net':
      return 'AT&T';
    case 'tmomail.net':
      return 'T-Mobile';
    case 'vtext.com':
      return 'Verizon';
    case 'messaging.sprintpcs.com':
      return 'Sprint';
    case 'vmobl.com':
      return 'Virgin Mobile';
    case 'sms.myboostmobile.com':
      return 'Boost Mobile';
    case 'mms.cricketwireless.net':
      return 'Cricket Wireless';
    case 'msg.fi.google.com':
      return 'Google Project Fi';
    case 'text.republicwireless.com':
      return 'Republic Wireless';
    // case 'vtext.com':
    //   return 'Straight Talk';
    case 'message.ting.com':
      return 'Ting';
    case 'email.uscc.net':
      return 'U.S. Cellular';
    default:
      return carrierTxt;
  }
}

export const AlertsUserPrefsModal = observer(({ open, handleClose }) => {
  const timeoutRef = useRef(null);
  const [emailBool, setEmailBool] = useState(false);
  const [emailInput, setEmailInput] = useState('');
  const [phoneBool, setPhoneBool] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState('');
  const [successMsg, setSuccessMsg] = useState('');
  const [carrier, setCarrier] = useState('default');
  const [soundBool, setSoundBool] = useState(false);
  const { userPreferencesStore } = useWebsocketStore();
  const userPreferences = userPreferencesStore.userPreferences ?? null;
  const userAlertPreferences = userPreferences?.userAlerts ?? null;

  useEffect(() => {
    if (userAlertPreferences) {
      setEmailBool(userAlertPreferences.isEmail ?? false);
      setPhoneBool(userAlertPreferences.isText ?? false);
      setSoundBool(userAlertPreferences.isSoundAlert ?? false);
      if (userAlertPreferences.phoneNumber) {
        const number = userAlertPreferences.phoneNumber?.split('@')[0] ?? null;
        const carrier =
          convertFromSmsGateWay(
            userAlertPreferences.phoneNumber?.split('@')[1]
          ) ?? null;
        if (number) setPhoneNumber(number);
        if (carrier) setCarrier(carrier);
      }
      if (userAlertPreferences.emailAddress)
        setEmailInput(userAlertPreferences.emailAddress);
    }
    return () => {
      if (timeoutRef?.current) clearTimeout(timeoutRef.current);
    };
  }, [userAlertPreferences]);

  const sendUserPrefs = () => {
    const phoneNumberResult = phoneNumber + '@' + convertToSmsGateWay(carrier);
    const json = {
      userAlerts: {
        isEmail: emailBool,
        isText: phoneBool,
        isSoundAlert: soundBool,
        emailAddress: emailInput,
        phoneNumber: phoneNumberResult,
      },
    };
    sendUserPreferences(json);
    setSuccessMsg('User preferences updated.');
    const timer = setTimeout(() => {
      setSuccessMsg('');
    }, 2000);
    timeoutRef.current = timer;
  };
  return (
    <Modal open={open} onClose={handleClose} onBackdropClick={handleClose}>
      <div className={style.container}>
        <header>
          <Body1 fontWeight={700} color={colors.lightGrey}>
            User Preferences
          </Body1>
        </header>
        <div className={style.main}>
          <div className={style.section}>
            <Body2 fontWeight={700} color={colors.lightGrey}>
              Email Alerts
            </Body2>
            <div className={style.inputs}>
              <CheckBox
                color={colors.lightGrey}
                checked={emailBool}
                onChange={(checked) => setEmailBool(checked)}
              >
                Enable Email Alerts
              </CheckBox>
              <div className={style.inputAndLabel}>
                <Body3 color={colors.lightGrey} fontWeight={500}>
                  Email:
                </Body3>
                <BoxInput
                  fontSize={fontSizes.body3}
                  value={emailInput}
                  setValue={(value) => setEmailInput(value)}
                />
              </div>
            </div>
          </div>
          <div className={style.section}>
            <Body2 fontWeight={700} color={colors.lightGrey}>
              Text Alerts
            </Body2>
            <div className={style.inputs}>
              <CheckBox
                color={colors.lightGrey}
                checked={phoneBool}
                onChange={(checked) => setPhoneBool(checked)}
              >
                Enable Text Alerts
              </CheckBox>
              <div className={style.inputAndLabel}>
                <Body3 color={colors.lightGrey} fontWeight={500}>
                  Phone Number:
                </Body3>
                <BoxInput
                  fontSize={fontSizes.body3}
                  value={phoneNumber}
                  setValue={(value) => setPhoneNumber(value)}
                />
              </div>
              <div className={style.inputAndLabel}>
                <Body3 color={colors.lightGrey} fontWeight={500}>
                  Carrier:
                </Body3>
                <select
                  className={style.select}
                  value={carrier}
                  onChange={({ target }) => setCarrier(target.value)}
                >
                  <option value="default">Select a carrier...</option>
                  {phoneCarriers.map((carrier) => (
                    <option key={carrier} value={carrier}>
                      {carrier}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          </div>
          <div className={style.section}>
            <Body2 fontWeight={700} color={colors.lightGrey}>
              Sound Alerts
            </Body2>
            <div className={style.inputs}>
              <CheckBox
                color={colors.lightGrey}
                checked={soundBool}
                onChange={(checked) => setSoundBool(checked)}
              >
                Enable Sound Alerts
              </CheckBox>
            </div>
          </div>
          <div className={style.messageDiv}>
            <Body3 fontWeight={700} color={colors.green}>
              {successMsg}
            </Body3>
          </div>
          <div className={style.buttons}>
            <TextButton
              margin="0 auto"
              fontSize="medium"
              width="30%"
              clickHandler={sendUserPrefs}
            >
              Apply Changes
            </TextButton>
            <TextButton
              margin="0 auto"
              fontSize="medium"
              width="30%"
              backgroundColor={colors.green}
              clickHandler={() => {
                sendUserPrefs();
                const timer = setTimeout(() => {
                  testAlert();
                }, 500);
                timeoutRef.current = timer;
              }}
            >
              Test Alerts
            </TextButton>
          </div>
        </div>
      </div>
    </Modal>
  );
});

AlertsUserPrefsModal.propTypes = {
  handleClose: PropTypes.any,
  open: PropTypes.any,
};

// {
//   "isEmail": true,
//   "isText": true,
//   "isSoundAlert": true,
//   "phoneNumber": "5033881940@tmomail.net",
//   "emailAddress": "dylan.whitej@gmail.com"
// }
